import { render } from "./InvoiceDeletedView.vue?vue&type=template&id=3f7f6d2f"
import script from "./InvoiceDeletedView.vue?vue&type=script&lang=js"
export * from "./InvoiceDeletedView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__